module.exports = __webpack_public_path__ + "img/VPC-Main.24efcd3.svg";